module.exports = __webpack_public_path__ + "img/imagCovid.8f3be1ec.jpg";